export enum ClientSubscriptionFreezeType {
    NoFreeze = 0,
    FreeFreeze = 1,
    PaidFreeze = 2
}

export enum ClientSubscriptionFreezeStatus {
    ScheduledFreeze = 1,
    FreezeInprogress = 2,
    FreezeCompleted = 3,
    FreezeCancelled = 4,
    FreezeStopped = 5
}

export enum FreezeRequestStatus{
    PENDING_REVIEW = 1,
    REQUIRE_MORE_INFO = 2,
    APPROVED_PENDING_PAYMENT = 3,
    APPROVED_PAYMENT_RECEIVED = 4,
    APPROVED_NO_PAYMENT_NEEDED = 5,
    FREEZE_APPLIED = 6,
    REJECTED = 7,
    VOID = 8,
    EXPIRED = 9,
}